export default function (appType: string, auth?: boolean) {
  const token = localStorage.getItem('authToken')

  localStorage.removeItem('authToken')

  if ( process.env.NODE_ENV === 'development' ) {
    ( appType === 'pro' )
      ? window.location.href = auth ? 'http://loc.surfe.pro:3000?token=' + token : 'http://loc.surfe.pro:3000'
      : window.location.href = auth ? 'https://loc.surfe.be/site/react-login?token=' + token : 'https://loc.surfe.be/index'
  } else {
    ( appType === 'pro' )
      ? window.location.href = auth ? '/site/react-login?token=' + token : '/web'
      : window.location.href = auth ? '/site/react-login?token=' + token : '/index'
  }
}
